import type { ResourceState } from '../../engine/world/types';

export const initialResources: ResourceState = {
  wood: 23560,
  stone: 18320,
  food: 14780,
  gold: 8560,
};
